import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import css from '../../css/sidebar/sidebar.module.scss';
import { ChatGroup } from '../../model/chatGroup';
import { Friend } from '../../model/friend';
import { getChatGroups, getFriendGroups, selectChatGroup } from '../../slice/chatGroupSlice';
import { getFriends, selectFriend } from '../../slice/friendSlice';
import { selectVoiceCall } from '../../slice/voiceCallSlice';
import { Footer } from './footer';
import { FriendList } from './friendList';
import { GroupList } from './groupList';
import { Header } from './header';

type SidebarProps = {
    width: number;
};

export const Sidebar: React.FC<SidebarProps> = (props) => {
    const dispatch = useDispatch();
    const { groups, friendGroups, groupPagination, friendGroupPagination } = useSelector(selectChatGroup);
    const { friends } = useSelector(selectFriend);
    const { group: joinedGroup, room: joinedRoom } = useSelector(selectVoiceCall);

    useEffect(() => {
        dispatch(getChatGroups());
        dispatch(getFriendGroups());
    }, [dispatch]);

    useEffect(() => {
        dispatch(getFriends());
    }, [dispatch, friendGroups]);

    const friendsWithGroup = friends
        .map((f) => ({
            friend: f,
            group: friendGroups.find((g) => g.name === f.name),
        }))
        .filter((x): x is { friend: Friend; group: ChatGroup } => x.group !== undefined);

    return (
        <div style={{ width: props.width }} className={css.sidebar}>
            <Header />
            <div className={css.main}>
                <div className={css.groupList}>
                    <p>グループ一覧</p>
                    <ul>
                        {groups.map((group, idx) => {
                            return (
                                <li key={idx}>
                                    <GroupList group={group} />
                                </li>
                            );
                        })}
                        {groupPagination.hasMore && (
                            <li className={css.more} onClick={() => dispatch(getChatGroups())}>
                                もっと見る
                            </li>
                        )}
                    </ul>
                </div>

                <div className={css.friendsList}>
                    <p>友達一覧</p>
                    <ul>
                        {friendsWithGroup.map((f, idx) => (
                            <li key={idx}>
                                <FriendList friend={f.friend} friendGroup={f.group} />
                            </li>
                        ))}
                        {friendGroupPagination.hasMore && (
                            <li className={css.more} onClick={() => dispatch(getFriendGroups())}>
                                もっと見る
                            </li>
                        )}
                    </ul>
                </div>
            </div>

            {joinedGroup && joinedRoom && <Footer groupId={joinedGroup.id} roomId={joinedRoom.id} />}
        </div>
    );
};
